import { OfferFragment } from '@occc/graphql';
import { useGetLocationsQuery } from '@occc-app/dataAccessLayer/location/queries';

import { StoreLocationConstraintFormValues } from '../store-location-or-groups.types';
import { getStoreLocationConstraint } from '../store-location-or-groups.utils';

export const useGetStoreLocationConstraint = (
  offer: OfferFragment | null | undefined,
): StoreLocationConstraintFormValues | null => {
  const storeLocationConstraint = getStoreLocationConstraint(offer);
  const storeLocationIds = storeLocationConstraint?.locations.map((item) => item.id) || [];
  const response = useGetLocationsQuery({
    skip: !storeLocationIds.length,
    variables: {
      filter: {
        uuidContains: storeLocationIds,
      },
    },
  });

  if (storeLocationConstraint) {
    return {
      ...storeLocationConstraint,
      locations: response.data,
    };
  }

  return null;
};
